module.exports = __webpack_public_path__ + "img/phone.1b0692b0.png";